<template>
  <div class="leaflet-map fill-height">
  </div>
</template>

<script>
import 'leaflet-map'
import * as Leaflet from 'leaflet'

export default {
  name: 'Map',
  props: {
    location: Object,
  },
  data () {
    return {
      marker: undefined,
      map: undefined,
    }
  },
  methods: {
    changeLocation () {
      this.marker.closePopup()
      this.map.setView([this.location.lat, this.location.lng], 18)
      this.marker.setLatLng([this.location.lat, this.location.lng])
      this.marker.bindPopup('Lat ' + this.location.lat + '<br />Lon ' + this.location.lng).openPopup()
    },
  },
  mounted () {
    Leaflet.Icon.Default.imagePath = 'https://unpkg.com/leaflet@1.0.3/dist/images'
    const map = Leaflet.map(this.$el).setView([Number.parseFloat(this.location.lat), Number.parseFloat(this.location.lng)], 12)

    Leaflet.tileLayer('https://{s}.tile.osm.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://osm.org/copyright">OSM</a>',
    }).addTo(map)

    const marker = Leaflet.marker([this.location.lat, this.location.lng], { title: 'Coordinates', alt: 'Coordinates', draggable: true })
      .addTo(map).on('dragend', () => {
        const lat = marker.getLatLng().lat.toFixed(8)
        const lon = marker.getLatLng().lng.toFixed(8)
        // const czoom = map.getZoom()
        // if (czoom < 18) { nzoom = czoom + 2 }
        // if (nzoom > 18) { nzoom = 18 }
        // if (czoom !== 18) { map.setView([lat, lon], nzoom) } else {  }
        this.$store.commit('set_current_address', this.location)
        map.setView([lat, lon])
        marker.bindPopup('Lat ' + lat + '<br />Lon ' + lon).openPopup()
      })
    this.map = map
    this.marker = marker
  },
  watch: {
    location: {
      deep: true,
      handler () {
        if (this.map !== undefined && this.marker !== undefined) {
          this.changeLocation()
        }
      },
    },
  },
}
</script>

<style lang="scss">
  @import "~leaflet/dist/leaflet.css";
</style>
